import { useState, useEffect } from 'react';

const API = import.meta.env.VITE_API_BASE || '/api';

/**
 * useSky, Sun/Moon/planet positions for the observer's location.
 *
 * Positions move slowly (Mercury, the fastest planet, moves ~1 deg/hour in
 * the sky) so we poll every 60 seconds. That's plenty granular for a "what's
 * up tonight" panel and barely touches the API.
 *
 * If no observer is set, returns null, the caller should hide the sky panel.
 */
export default function useSky(observer) {
  const [bodies, setBodies] = useState(null);
  const [error,  setError]  = useState(false);

  useEffect(() => {
    if (!observer?.lat || !observer?.lon) { setBodies(null); return; }
    let cancelled = false;

    const fetchSky = async () => {
      try {
        const r = await fetch(
          `${API}/sky?lat=${observer.lat}&lon=${observer.lon}`
            + (observer.elevation_m ? `&elevation=${observer.elevation_m}` : '')
        );
        if (!r.ok) throw new Error(`status ${r.status}`);
        const data = await r.json();
        if (!cancelled) { setBodies(data.bodies || []); setError(false); }
      } catch (e) {
        if (!cancelled) setError(true);
      }
    };

    fetchSky();
    const iv = setInterval(fetchSky, 60_000);
    return () => { cancelled = true; clearInterval(iv); };
  }, [observer?.lat, observer?.lon, observer?.elevation_m]);

  return { bodies, error };
}
